// Helpers de tracking client-side reusados por TODAS as capturas de lead.
// Meta Pixel + CAPI são disparados exclusivamente pelo GTM (que já lê seus
// próprios cookies _fbc/_fbp e gera event_id). Aqui só emitimos os eventos
// customizados no dataLayer para o GTM ouvir.

import type { LeadCaptureSource } from "@/lib/leads/taxonomy";

export type PixelLeadInput = {
  source: LeadCaptureSource;
  area?: string | null;
  posNome?: string | null;
  classificacao?: string | null;
  stage?: "partial" | "final";
  value?: number;
  currency?: string;
};

/**
 * Dispara o evento no dataLayer após sucesso do servidor. O GTM cuida do
 * disparo do Meta Pixel + CAPI (incluindo event_id/fbc/fbp).
 */
export function pushPixelLead(input: PixelLeadInput): void {
  if (typeof window === "undefined") return;
  const stage = input.stage ?? "final";
  const w = window as typeof window & {
    dataLayer?: Array<Record<string, unknown>>;
  };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({
    event: stage === "partial" ? "feo_lead_saved" : "feo_lead_qualified",
    lead_source: input.source,
    lead_area: input.area ?? null,
    lead_product: input.posNome ?? null,
    lead_classificacao: input.classificacao ?? null,
    lead_value: input.value ?? null,
    lead_currency: input.currency ?? null,
  });
}


export type UtmsBundle = {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  utm_term: string;
};

export function readUtmsFromUrl(): UtmsBundle {
  if (typeof window === "undefined") {
    return { utm_source: "", utm_medium: "", utm_campaign: "", utm_content: "", utm_term: "" };
  }
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source") ?? "",
    utm_medium: p.get("utm_medium") ?? "",
    utm_campaign: p.get("utm_campaign") ?? "",
    utm_content: p.get("utm_content") ?? "",
    utm_term: p.get("utm_term") ?? "",
  };
}
